/**
 * Copyright © Magento, Inc. All rights reserved.
 * See COPYING.txt for license details.
 */

define('vimeo/vimeo-wrapper',[
    'vimeo'
], function (Player) {
    'use strict';

    window.Vimeo = window.Vimeo || {
        'Player': Player
    };
});

